import styled from '@mui/material/styles/styled';
import List from '@mui/material/List';
import Box from '@mui/material/Box';

export const CardItem = styled(Box)(() => ({
  display: 'flex', 
  alignItems: 'center',
  justifyContent: 'space-between', 
  gap: '8px', 
  marginBottom: 16
}));
export const StyledList = styled(List)(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  height: '100%',
  maxHeight: '500px',
  overflowY: 'auto',
  ...theme.scrollbars.paper,
}));